import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=bb0c51dc&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"
import style0 from "./NoData.vue?vue&type=style&index=0&id=bb0c51dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c51dc",
  null
  
)

export default component.exports